import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, withModifiers as _withModifiers } from "vue";
import _imports_0 from '../../../assets/mapv2/defaultImage.jpg';
const _hoisted_1 = {
  class: "leftSlide"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "conWrap"
};
const _hoisted_4 = {
  class: "contitle"
};
const _hoisted_5 = {
  class: "relative"
};
const _hoisted_6 = {
  class: "p16"
};
const _hoisted_7 = {
  class: "mt16"
};
const _hoisted_8 = {
  key: 0,
  class: "conditionul"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "ullist mt16mb10"
};
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
  class: "innerbox"
};
const _hoisted_13 = {
  class: "imgbox"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "el-form-w2"
};
const _hoisted_16 = {
  class: "slideright coordinput"
};
const _hoisted_17 = {
  class: "slideright coordinput"
};
const _hoisted_18 = {
  class: "rotateorscale"
};
const _hoisted_19 = {
  class: "p16"
};
const _hoisted_20 = {
  class: "ullist"
};
const _hoisted_21 = ["onClick"];
const _hoisted_22 = {
  class: "innerbox"
};
const _hoisted_23 = {
  class: "imgbox"
};
const _hoisted_24 = ["src"];
const _hoisted_25 = {
  class: "typeWrap p1216"
};
const _hoisted_26 = {
  class: "typelist"
};
const _hoisted_27 = {
  class: "title"
};
const _hoisted_28 = {
  class: "titlebox"
};
const _hoisted_29 = {
  class: "imgbox"
};
const _hoisted_30 = ["src"];
const _hoisted_31 = {
  key: 1,
  src: _imports_0,
  alt: ""
};
const _hoisted_32 = {
  class: "title"
};
const _hoisted_33 = {
  class: "titlebox"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = ["onClick"];
const _hoisted_36 = {
  class: "ullist"
};
const _hoisted_37 = ["onClick"];
const _hoisted_38 = {
  class: "innerbox"
};
const _hoisted_39 = {
  class: "imgbox"
};
const _hoisted_40 = ["src"];
const _hoisted_41 = {
  class: "pointWrap p1216"
};
const _hoisted_42 = {
  class: "searchwrap"
};
const _hoisted_43 = {
  class: "pointcell"
};
const _hoisted_44 = {
  class: "pointlist"
};
const _hoisted_45 = ["onClick"];
const _hoisted_46 = {
  key: 0,
  class: "imgbox"
};
const _hoisted_47 = ["src"];
const _hoisted_48 = {
  class: "txtbox"
};
const _hoisted_49 = {
  class: "title"
};
const _hoisted_50 = {
  key: 0
};
const _hoisted_51 = ["onClick"];
const _hoisted_52 = {
  class: "ullist big"
};
const _hoisted_53 = ["onClick"];
const _hoisted_54 = {
  class: "innerbox"
};
const _hoisted_55 = {
  class: "imgbox"
};
const _hoisted_56 = ["src"];
const _hoisted_57 = {
  class: "p16"
};
const _hoisted_58 = {
  class: "ullist big"
};
const _hoisted_59 = ["onClick"];
const _hoisted_60 = {
  class: "innerbox"
};
const _hoisted_61 = {
  class: "imgbox"
};
const _hoisted_62 = ["src"];
const _hoisted_63 = {
  class: "p16"
};
const _hoisted_64 = {
  class: "p1216 routebtngroup"
};
const _hoisted_65 = {
  class: "toolbox"
};
const _hoisted_66 = ["onClick"];
const _hoisted_67 = ["onClick"];
const _hoisted_68 = {
  class: "routetypelist"
};
const _hoisted_69 = {
  class: "innerbox"
};
const _hoisted_70 = {
  class: "toolbox"
};
const _hoisted_71 = ["onClick"];
const _hoisted_72 = ["onClick"];
const _hoisted_73 = {
  class: "mb15"
};
const _hoisted_74 = ["src"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CaretBottom = _resolveComponent("CaretBottom");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_collapse_item = _resolveComponent("el-collapse-item");
  const _component_uploadfile = _resolveComponent("uploadfile");
  const _component_el_button = _resolveComponent("el-button");
  const _component_map_position = _resolveComponent("map-position");
  const _component_el_radio = _resolveComponent("el-radio");
  const _component_el_radio_group = _resolveComponent("el-radio-group");
  const _component_fillcolor = _resolveComponent("fillcolor");
  const _component_mapshadow = _resolveComponent("mapshadow");
  const _component_el_input_number = _resolveComponent("el-input-number");
  const _component_el_slider = _resolveComponent("el-slider");
  const _component_el_checkbox = _resolveComponent("el-checkbox");
  const _component_mapdisplay = _resolveComponent("mapdisplay");
  const _component_typebtn = _resolveComponent("typebtn");
  const _component_slider_input = _resolveComponent("slider-input");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_Plus = _resolveComponent("Plus");
  const _component_el_empty = _resolveComponent("el-empty");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_pointtext = _resolveComponent("pointtext");
  const _component_pointicon = _resolveComponent("pointicon");
  const _component_Search = _resolveComponent("Search");
  const _component_gpickr = _resolveComponent("gpickr");
  const _component_CaretRight = _resolveComponent("CaretRight");
  const _component_el_collapse = _resolveComponent("el-collapse");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("ul", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.leftSlideArr, (item, index) => {
    return _openBlock(), _createElementBlock("li", {
      class: _normalizeClass([{
        'active': index === $data.leftIndex
      }]),
      key: index,
      onClick: $event => $options.switchSlide(index)
    }, [_cache[85] || (_cache[85] = _createElementVNode("i", {
      class: "left-view"
    }, null, -1)), _createElementVNode("h5", null, _toDisplayString(item.name), 1)], 10, _hoisted_2);
  }), 128))])]), _createElementVNode("div", {
    class: _normalizeClass(["configWrap", {
      'hide': !$data.leftconflag
    }])
  }, [_withDirectives(_createElementVNode("div", {
    class: "launch icon-shrink",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.launchHandle && $options.launchHandle(...args))
  }, null, 512), [[_vShow, !$data.leftconflag]]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("span", null, _toDisplayString($data.titleInfo[$data.leftIndex].name), 1), _createElementVNode("i", {
    class: "icon-shrink",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.launchHandle && $options.launchHandle(...args))
  })]), _createVNode(_component_el_collapse, {
    modelValue: $data.activeNames,
    "onUpdate:modelValue": _cache[84] || (_cache[84] = $event => $data.activeNames = $event),
    onChange: $options.handleChange
  }, {
    default: _withCtx(() => [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_collapse_item, {
      name: "1"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[86] || (_cache[86] = _createElementVNode("span", null, "名称", -1))]),
      default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.formlabel.title), 1)]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $props.form.title,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $props.form.title = $event),
          onInput: _cache[3] || (_cache[3] = $event => $options.inputChange($event, 'title'))
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [_createElementVNode("span", null, _toDisplayString($props.formlabel.toptitle), 1), _cache[87] || (_cache[87] = _createElementVNode("i", {
          class: "icon icon-prompt"
        }, null, -1))]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $props.form.toptitle,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $props.form.toptitle = $event),
          onInput: _cache[5] || (_cache[5] = $event => $options.inputChange($event, 'toptitle'))
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "2"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[88] || (_cache[88] = _createElementVNode("span", null, "背景", -1))]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_withDirectives(_createVNode(_component_uploadfile, {
        uploadList: $props.form.background_img,
        name: "background_img",
        id: "pc",
        field: $props.formfield.background_img,
        width: 90,
        height: 90,
        onFileList: _cache[6] || (_cache[6] = $event => $options.fileListHandle($event, 'background_img'))
      }, null, 8, ["uploadList", "field"]), [[_vShow, !$props.isMobile]]), _withDirectives(_createVNode(_component_uploadfile, {
        uploadList: $props.form.app_bg_img,
        name: "app_bg_img",
        id: "mobile",
        field: $props.formfield.app_bg_img,
        width: 90,
        height: 90,
        onFileList: _cache[7] || (_cache[7] = $event => $options.fileListHandle($event, 'app_bg_img'))
      }, null, 8, ["uploadList", "field"]), [[_vShow, $props.isMobile]]), _createVNode(_component_el_button, {
        class: "materialbtn",
        onClick: _cache[8] || (_cache[8] = $event => $options.openSourceMaterial(0))
      }, {
        default: _withCtx(() => [...(_cache[89] || (_cache[89] = [_createTextVNode("素材库", -1)]))]),
        _: 1
      })])]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "3"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[90] || (_cache[90] = _createElementVNode("span", null, "logo", -1))]),
      default: _withCtx(() => [_createVNode(_component_uploadfile, {
        class: "mb16",
        name: "logo",
        uploadList: $props.form.logo,
        field: $props.formfield.logo,
        onFileList: _cache[9] || (_cache[9] = $event => $options.fileListHandle($event, 'logo'))
      }, null, 8, ["uploadList", "field"]), _createVNode(_component_map_position, {
        name: "logopos",
        value: $props.style.logopos
      }, null, 8, ["value"])]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "4"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[91] || (_cache[91] = _createElementVNode("span", null, "图例", -1))]),
      default: _withCtx(() => [_createVNode(_component_uploadfile, {
        class: "mb16",
        name: "pickey",
        uploadList: $props.form.pickey,
        field: $props.formfield.pickey,
        onFileList: _cache[10] || (_cache[10] = $event => $options.fileListHandle($event, 'pickey'))
      }, null, 8, ["uploadList", "field"]), _createVNode(_component_map_position, {
        name: "pickeypos",
        value: $props.style.pickeypos
      }, null, 8, ["value"])]),
      _: 1
    })], 512), [[_vShow, $data.leftIndex === 0]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_radio_group, {
      modelValue: $props.form.mapmodetype,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => $props.form.mapmodetype = $event),
      onChange: _cache[12] || (_cache[12] = $event => $options.inputChange($event, 'mapmodetype'))
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.formoption.mapmodetype, (item, index) => {
        return _openBlock(), _createBlock(_component_el_radio, {
          key: index,
          value: item.title
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(item.title), 1)]),
          _: 2
        }, 1032, ["value"]);
      }), 128))]),
      _: 1
    }, 8, ["modelValue"])]), _withDirectives(_createVNode(_component_el_collapse_item, {
      name: "5"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[92] || (_cache[92] = _createElementVNode("span", null, "地图图片", -1))]),
      default: _withCtx(() => [$props.form.app_static_img !== undefined ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_withDirectives(_createVNode(_component_uploadfile, {
        name: "static_img",
        uploadList: $props.form.static_img === '' ? [] : $props.form.static_img,
        field: $props.formfield.static_img,
        width: 90,
        height: 90,
        onFileList: _cache[13] || (_cache[13] = $event => $options.fileListHandle($event, 'static_img'))
      }, null, 8, ["uploadList", "field"]), [[_vShow, !$props.isMobile]]), _withDirectives(_createVNode(_component_uploadfile, {
        name: "app_static_img",
        uploadList: $props.form.app_static_img.length === 0 ? [] : $props.form.app_static_img,
        field: $props.formfield.app_static_img,
        width: 90,
        height: 90,
        onFileList: _cache[14] || (_cache[14] = $event => $options.fileListHandle($event, 'app_static_img'))
      }, null, 8, ["uploadList", "field"]), [[_vShow, $props.isMobile]])], 64)) : _createCommentVNode("", true), $props.form.app_static_img === undefined ? (_openBlock(), _createBlock(_component_uploadfile, {
        key: 1,
        name: "static_img",
        uploadList: $props.form.static_img === '' ? [] : $props.form.static_img,
        field: $props.formfield.static_img,
        width: 90,
        height: 90,
        onFileList: _cache[15] || (_cache[15] = $event => $options.fileListHandle($event, 'static_img'))
      }, null, 8, ["uploadList", "field"])) : _createCommentVNode("", true), _createVNode(_component_el_button, {
        class: "w100 mt10",
        plain: "",
        onClick: $options.adjustExtent
      }, {
        default: _withCtx(() => [...(_cache[93] || (_cache[93] = [_createTextVNode("调整覆盖范围", -1)]))]),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    }, 512), [[_vShow, $props.form.mapmodetype === $props.formoption.mapmodetype[0].title]]), $props.formoption.filltype && $props.form.mapmodetype === $props.formoption.mapmodetype[1].title ? (_openBlock(), _createBlock(_component_el_collapse_item, {
      key: 0,
      name: "34"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[94] || (_cache[94] = _createElementVNode("span", null, "地图样式", -1))]),
      default: _withCtx(() => [_createVNode(_component_el_radio_group, {
        class: "flexwrap",
        modelValue: $props.form.filltype,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = $event => $props.form.filltype = $event),
        onChange: _cache[19] || (_cache[19] = $event => $options.inputChange($event, 'filltype'))
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio, {
          value: $props.formoption.filltype[0].title
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($props.formoption.filltype[0].title), 1)]),
          _: 1
        }, 8, ["value"]), _createVNode(_component_el_radio, {
          value: $props.formoption.filltype[1].title
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($props.formoption.filltype[1].title), 1)]),
          _: 1
        }, 8, ["value"]), _withDirectives(_createElementVNode("div", _hoisted_7, [$props.form.fillcolor.length > 1 ? (_openBlock(), _createElementBlock("ul", _hoisted_8, [_createElementVNode("li", {
          class: _normalizeClass({
            'active': $data.fillcolorIndex === $props.form.fillcolor.length + 1
          }),
          onClick: _cache[16] || (_cache[16] = $event => $data.fillcolorIndex = $props.form.fillcolor.length + 1)
        }, "全部", 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.form.fillcolor, (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            class: _normalizeClass({
              'active': $data.fillcolorIndex === index
            }),
            key: item,
            onClick: $event => $data.fillcolorIndex = index
          }, _toDisplayString(item.name), 11, _hoisted_9);
        }), 128))])) : _createCommentVNode("", true), $props.form.fillcolor ? (_openBlock(), _createBlock(_component_fillcolor, {
          key: 1,
          title: "fillcolor",
          value: $props.form.fillcolor,
          index: $data.fillcolorIndex + 1,
          onChange: $options.fillcolorChange
        }, null, 8, ["value", "index", "onChange"])) : _createCommentVNode("", true)], 512), [[_vShow, $props.form.filltype === $props.formoption.filltype[0].title]]), _withDirectives(_createElementVNode("div", null, [_cache[97] || (_cache[97] = _createElementVNode("span", {
          class: "desc diff1"
        }, [_createElementVNode("i", null, "*"), _createTextVNode("第一步：选择模板图片或者上传本地图片")], -1)), _createElementVNode("ul", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.fillimagesOptions, (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            class: _normalizeClass({
              'active': $data.fillimageindex === index + 1
            }),
            key: index,
            onClick: $event => $options.inputChange(index + 1, 'fillimageindex')
          }, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_cache[95] || (_cache[95] = _createElementVNode("i", {
            class: "icon-right"
          }, null, -1)), _createElementVNode("img", {
            src: item.url,
            alt: ""
          }, null, 8, _hoisted_14)]), _createElementVNode("h5", null, _toDisplayString(item.name), 1)])], 10, _hoisted_11);
        }), 128))]), _createVNode(_component_uploadfile, {
          name: "fillimage",
          uploadList: $props.form.fillimage,
          field: $props.formfield.fillimage,
          width: 90,
          height: 90,
          onFileList: _cache[17] || (_cache[17] = $event => $options.fileListHandle($event, 'fillimage'))
        }, null, 8, ["uploadList", "field"]), _cache[98] || (_cache[98] = _createElementVNode("span", {
          class: "desc diff1"
        }, [_createElementVNode("i", null, "*"), _createTextVNode("第二步：在右侧地图区域可选中图片放大缩小拖拽调整")], -1)), _cache[99] || (_cache[99] = _createElementVNode("span", {
          class: "desc diff1"
        }, [_createElementVNode("i", null, "*"), _createTextVNode("第三步：点击确定生成填充效果")], -1)), _createVNode(_component_el_button, {
          class: "w100 mt10",
          plain: "",
          onClick: $options.confirmClip
        }, {
          default: _withCtx(() => [...(_cache[96] || (_cache[96] = [_createTextVNode("确定", -1)]))]),
          _: 1
        }, 8, ["onClick"])], 512), [[_vShow, $props.form.filltype === $props.formoption.filltype[1].title]])]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    })) : _createCommentVNode("", true), $props.form.viewShadow !== undefined ? (_openBlock(), _createBlock(_component_el_collapse_item, {
      key: 1,
      name: "37"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[100] || (_cache[100] = _createElementVNode("span", null, "投影", -1))]),
      default: _withCtx(() => [$props.form.viewShadow !== undefined ? (_openBlock(), _createBlock(_component_mapshadow, {
        key: 0,
        value: $props.form,
        onChange: $options.mapShadowList
      }, null, 8, ["value", "onChange"])) : _createCommentVNode("", true)]),
      _: 1
    })) : _createCommentVNode("", true), _createVNode(_component_el_collapse_item, {
      name: "6"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, {
        class: "icon"
      }, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[101] || (_cache[101] = _createElementVNode("span", null, "层级", -1))]),
      default: _withCtx(() => [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [...(_cache[102] || (_cache[102] = [_createElementVNode("span", null, "最小", -1)]))]),
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $props.form.minZoom,
          "onUpdate:modelValue": _cache[20] || (_cache[20] = $event => $props.form.minZoom = $event),
          min: 0,
          max: $props.form.zoom,
          "controls-position": "right",
          onInput: _cache[21] || (_cache[21] = $event => $options.inputChange($event, 'minZoom'))
        }, null, 8, ["modelValue", "max"])]),
        _: 1
      }), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [...(_cache[103] || (_cache[103] = [_createElementVNode("span", null, "最大", -1)]))]),
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $props.form.maxZoom,
          "onUpdate:modelValue": _cache[22] || (_cache[22] = $event => $props.form.maxZoom = $event),
          min: $props.form.zoom,
          max: 28,
          "controls-position": "right",
          onInput: _cache[23] || (_cache[23] = $event => $options.inputChange($event, 'maxZoom'))
        }, null, 8, ["modelValue", "min"])]),
        _: 1
      })]), _createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [...(_cache[104] || (_cache[104] = [_createElementVNode("span", null, "初始层级", -1)]))]),
        default: _withCtx(() => [_createVNode(_component_el_input_number, {
          modelValue: $props.form.zoom,
          "onUpdate:modelValue": _cache[24] || (_cache[24] = $event => $props.form.zoom = $event),
          min: $props.form.minZoom,
          max: $props.form.maxZoom,
          "controls-position": "right",
          onInput: _cache[25] || (_cache[25] = $event => $options.inputChange($event, 'zoom'))
        }, null, 8, ["modelValue", "min", "max"])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "7"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[105] || (_cache[105] = _createElementVNode("span", null, "位置", -1))]),
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        class: "nosliderbar"
      }, {
        label: _withCtx(() => [...(_cache[106] || (_cache[106] = [_createElementVNode("span", null, "左右", -1)]))]),
        default: _withCtx(() => [_createVNode(_component_el_slider, {
          modelValue: $props.form.centerX,
          "onUpdate:modelValue": _cache[26] || (_cache[26] = $event => $props.form.centerX = $event),
          step: 0.0001,
          min: $props.form.centerXmin,
          max: $props.form.centerXmax,
          onInput: _cache[27] || (_cache[27] = $event => $options.inputChange($event, 'centerX'))
        }, null, 8, ["modelValue", "min", "max"]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_el_input_number, {
          modelValue: $props.form.centerX,
          "onUpdate:modelValue": _cache[28] || (_cache[28] = $event => $props.form.centerX = $event),
          "controls-position": "right",
          onInput: _cache[29] || (_cache[29] = $event => $options.inputChange($event, 'centerX'))
        }, null, 8, ["modelValue"])])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        class: "nosliderbar"
      }, {
        label: _withCtx(() => [...(_cache[107] || (_cache[107] = [_createElementVNode("span", null, "上下", -1)]))]),
        default: _withCtx(() => [_createVNode(_component_el_slider, {
          modelValue: $props.form.centerY,
          "onUpdate:modelValue": _cache[30] || (_cache[30] = $event => $props.form.centerY = $event),
          step: 0.0001,
          min: $props.form.centerYmin,
          max: $props.form.centerYmax,
          onInput: _cache[31] || (_cache[31] = $event => $options.inputChange($event, 'centerY'))
        }, null, 8, ["modelValue", "min", "max"]), _createElementVNode("div", _hoisted_17, [_createVNode(_component_el_input_number, {
          modelValue: $props.form.centerY,
          "onUpdate:modelValue": _cache[32] || (_cache[32] = $event => $props.form.centerY = $event),
          "controls-position": "right",
          onInput: _cache[33] || (_cache[33] = $event => $options.inputChange($event, 'centerY'))
        }, null, 8, ["modelValue"])])]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "8"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[108] || (_cache[108] = _createElementVNode("span", null, "旋转与缩放", -1))]),
      default: _withCtx(() => [_createElementVNode("ul", _hoisted_18, [_createElementVNode("li", null, [_createVNode(_component_el_checkbox, {
        modelValue: $props.form.scale,
        "onUpdate:modelValue": _cache[34] || (_cache[34] = $event => $props.form.scale = $event),
        label: "禁止缩放",
        onChange: _cache[35] || (_cache[35] = $event => $options.inputChange($event, 'scale'))
      }, null, 8, ["modelValue"])]), _createElementVNode("li", null, [_createVNode(_component_el_checkbox, {
        modelValue: $props.form.rotate,
        "onUpdate:modelValue": _cache[36] || (_cache[36] = $event => $props.form.rotate = $event),
        label: "禁止旋转",
        onChange: _cache[37] || (_cache[37] = $event => $options.inputChange($event, 'rotate'))
      }, null, 8, ["modelValue"])]), _createElementVNode("li", null, [_createVNode(_component_el_checkbox, {
        modelValue: $props.form.translate,
        "onUpdate:modelValue": _cache[38] || (_cache[38] = $event => $props.form.translate = $event),
        label: "禁止平移",
        onChange: _cache[39] || (_cache[39] = $event => $options.inputChange($event, 'translate'))
      }, null, 8, ["modelValue"])])])]),
      _: 1
    })], 512), [[_vShow, $data.leftIndex === 1]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_tabs, {
      modelValue: $data.switchtab1,
      "onUpdate:modelValue": _cache[47] || (_cache[47] = $event => $data.switchtab1 = $event),
      class: "switchTab1",
      onTabClick: $options.handleClick
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "样式",
        name: "first"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_radio_group, {
          modelValue: $props.form.showtype,
          "onUpdate:modelValue": _cache[40] || (_cache[40] = $event => $props.form.showtype = $event),
          onChange: _cache[41] || (_cache[41] = $event => $options.inputChange($event, 'showtype'))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_radio, {
            value: 1
          }, {
            default: _withCtx(() => [...(_cache[109] || (_cache[109] = [_createTextVNode("显示分类", -1)]))]),
            _: 1
          }), _createVNode(_component_el_radio, {
            value: 2
          }, {
            default: _withCtx(() => [...(_cache[110] || (_cache[110] = [_createTextVNode("隐藏分类", -1)]))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue"])]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_collapse_item, {
          name: "9"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[111] || (_cache[111] = _createElementVNode("span", null, "选择样式", -1))]),
          default: _withCtx(() => [_createElementVNode("ul", _hoisted_20, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.typeOptions, (item, index) => {
            return _openBlock(), _createElementBlock("li", {
              class: _normalizeClass({
                'active': $data.typeStyleIndex === index
              }),
              key: index,
              onClick: $event => $options.typeStyleChange(item, index)
            }, [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[112] || (_cache[112] = _createElementVNode("i", {
              class: "icon-right"
            }, null, -1)), _createElementVNode("img", {
              src: item.url,
              alt: ""
            }, null, 8, _hoisted_24)]), _createElementVNode("h5", null, "样式" + _toDisplayString(index + 1), 1)])], 10, _hoisted_21);
          }), 128))])]),
          _: 1
        }), _createVNode(_component_el_collapse_item, {
          name: "26"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[113] || (_cache[113] = _createElementVNode("span", null, "排列", -1))]),
          default: _withCtx(() => [_createVNode(_component_mapdisplay, {
            title: "typedisplay",
            value: $props.style.typedisplay,
            onDisplay: $options.displayHandle
          }, null, 8, ["value", "onDisplay"])]),
          _: 1
        }), _withDirectives(_createVNode(_component_el_collapse_item, {
          name: "10"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[114] || (_cache[114] = _createElementVNode("span", null, "分类按钮", -1))]),
          default: _withCtx(() => [_createVNode(_component_typebtn, {
            ref: "typebtn",
            name: "typebtn",
            styleIndex: $data.typeStyleIndex,
            value: $props.style.typebtn,
            onOpenSource: $options.opentypeSourceMaterial
          }, null, 8, ["styleIndex", "value", "onOpenSource"])]),
          _: 1
        }, 512), [[_vShow, $data.typeStyleIndex !== 2]]), _withDirectives(_createVNode(_component_el_collapse_item, {
          name: "11"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[115] || (_cache[115] = _createElementVNode("span", null, "外观", -1))]),
          default: _withCtx(() => [_withDirectives(_createElementVNode("div", null, [_createVNode(_component_slider_input, {
            title: "分类宽度",
            max: 500,
            size: 200
          }), _cache[116] || (_cache[116] = _createElementVNode("div", {
            class: "title-label mb8"
          }, "分类背景", -1))], 512), [[_vShow, $data.typeStyleIndex === 1]]), _withDirectives(_createVNode(_component_el_form_item, null, {
            label: _withCtx(() => [...(_cache[117] || (_cache[117] = [_createElementVNode("span", null, "分类主题色", -1)]))]),
            _: 1
          }, 512), [[_vShow, $data.typeStyleIndex === 2]])]),
          _: 1
        }, 512), [[_vShow, $data.typeStyleIndex !== 0]]), _createVNode(_component_el_collapse_item, {
          name: "12"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[118] || (_cache[118] = _createElementVNode("span", null, "定位", -1))]),
          default: _withCtx(() => [_createVNode(_component_map_position, {
            showWidth: false,
            name: "typepos",
            value: $props.style.typepos
          }, null, 8, ["value"])]),
          _: 1
        })], 512), [[_vShow, $props.form.showtype === 1]])]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "数据",
        name: "second"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_button, {
          class: "w100",
          plain: "",
          onClick: _cache[42] || (_cache[42] = $event => $options.typehandle(0))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Plus)]),
            _: 1
          }), _cache[119] || (_cache[119] = _createTextVNode("添加分类", -1))]),
          _: 1
        }), _createElementVNode("ul", _hoisted_26, [_createElementVNode("li", null, [_cache[120] || (_cache[120] = _createElementVNode("div", {
          class: "imgbox"
        }, [_createElementVNode("img", {
          src: _imports_0,
          alt: ""
        })], -1)), _createElementVNode("div", _hoisted_27, [_createVNode(_component_el_input, {
          modelValue: $props.form.typeallname,
          "onUpdate:modelValue": _cache[43] || (_cache[43] = $event => $props.form.typeallname = $event),
          onInput: _cache[44] || (_cache[44] = $event => $options.inputChange($event, 'typeallname'))
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_28, [_createVNode(_component_el_checkbox, {
          modelValue: $props.form.typeall,
          "onUpdate:modelValue": _cache[45] || (_cache[45] = $event => $props.form.typeall = $event),
          onChange: _cache[46] || (_cache[46] = $event => $options.inputChange($event, 'typeall'))
        }, null, 8, ["modelValue"])])]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.typelist, (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: index
          }, [_createElementVNode("div", _hoisted_29, [item.itemformdata.icon.length > 0 ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: item.itemformdata.icon[0].fileUrl,
            alt: ""
          }, null, 8, _hoisted_30)) : (_openBlock(), _createElementBlock("img", _hoisted_31))]), _createElementVNode("div", _hoisted_32, _toDisplayString(item.itemformdata.title), 1), _createElementVNode("div", _hoisted_33, [_createElementVNode("i", {
            class: "icon icon-edit",
            onClick: $event => $options.typehandle(1, item)
          }, null, 8, _hoisted_34), _createElementVNode("i", {
            class: "icon icon-delete",
            onClick: $event => $options.typehandle(3, item)
          }, null, 8, _hoisted_35)])]);
        }), 128))]), _withDirectives(_createVNode(_component_el_empty, {
          "image-size": 80,
          description: "暂无数据"
        }, null, 512), [[_vShow, $props.typelist.length === 0]])])]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onTabClick"])], 512), [[_vShow, $data.leftIndex === 2]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_tabs, {
      modelValue: $data.switchtab2,
      "onUpdate:modelValue": _cache[52] || (_cache[52] = $event => $data.switchtab2 = $event),
      class: "switchTab1",
      onTabClick: $options.handleClick
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "样式",
        name: "first"
      }, {
        default: _withCtx(() => [_cache[126] || (_cache[126] = _createElementVNode("div", {
          class: "title-label p1216"
        }, "全局设置", -1)), _createVNode(_component_el_collapse_item, {
          name: "23"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[121] || (_cache[121] = _createElementVNode("span", null, "选择样式", -1))]),
          default: _withCtx(() => [_createElementVNode("ul", _hoisted_36, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.pointOptions, (item, index) => {
            return _openBlock(), _createElementBlock("li", {
              class: _normalizeClass([{
                'active': $data.pointStyleIndex === index
              }, {
                'none': $props.form.cTemplateScore === 1 && index !== 1
              }]),
              key: index,
              onClick: $event => $options.pointStyleChange(item, index)
            }, [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, [_cache[122] || (_cache[122] = _createElementVNode("i", {
              class: "icon-right"
            }, null, -1)), _createElementVNode("img", {
              src: item.url,
              alt: ""
            }, null, 8, _hoisted_40)]), _createElementVNode("h5", null, _toDisplayString(item.name), 1)])], 10, _hoisted_37);
          }), 128))])]),
          _: 1
        }), _withDirectives(_createVNode(_component_el_collapse_item, {
          name: "13"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[123] || (_cache[123] = _createElementVNode("span", null, "点位名称", -1))]),
          default: _withCtx(() => [(_openBlock(), _createBlock(_component_pointtext, {
            pointStyleIndex: $data.pointStyleIndex,
            value: $props.style.pointtext,
            key: new Date().toString()
          }, null, 8, ["pointStyleIndex", "value"]))]),
          _: 1
        }, 512), [[_vShow, $data.pointItem.text]]), _withDirectives(_createVNode(_component_el_collapse_item, {
          name: "14"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[124] || (_cache[124] = _createElementVNode("span", null, "点位图片", -1))]),
          default: _withCtx(() => [(_openBlock(), _createBlock(_component_pointicon, {
            title: "pointpic",
            value: $props.style.pointpic,
            key: new Date().toString()
          }, null, 8, ["value"]))]),
          _: 1
        }, 512), [[_vShow, $data.pointItem.pic]]), _withDirectives(_createVNode(_component_el_collapse_item, {
          name: "15"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[125] || (_cache[125] = _createElementVNode("span", null, "点位图标", -1))]),
          default: _withCtx(() => [(_openBlock(), _createBlock(_component_pointicon, {
            title: "pointicon",
            value: $props.style.pointicon,
            key: new Date().toString()
          }, null, 8, ["value"]))]),
          _: 1
        }, 512), [[_vShow, $data.pointItem.icon]])]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "数据",
        name: "second"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", _hoisted_42, [_createVNode(_component_el_icon, {
          onClick: _cache[48] || (_cache[48] = $event => $options.pointhandle(2, $data.pointkey))
        }, {
          default: _withCtx(() => [_createVNode(_component_Search)]),
          _: 1
        }), _createVNode(_component_el_input, {
          modelValue: $data.pointkey,
          "onUpdate:modelValue": _cache[49] || (_cache[49] = $event => $data.pointkey = $event),
          placeholder: "搜索",
          onKeydown: _cache[50] || (_cache[50] = _withKeys($event => $options.pointhandle(2, $data.pointkey), ["enter"]))
        }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_43, [_createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[51] || (_cache[51] = $event => $options.pointhandle(0))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Plus)]),
            _: 1
          }), _cache[127] || (_cache[127] = _createTextVNode("添加点位", -1))]),
          _: 1
        }), _createElementVNode("p", null, "共" + _toDisplayString($props.pointlist.length) + "条", 1)]), _createElementVNode("ul", _hoisted_44, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.pointlist, (item, index) => {
          return _openBlock(), _createElementBlock("li", {
            key: index,
            onClick: $event => $options.pointhandle(1, item)
          }, [item.itemformdata[4].length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_46, [_createElementVNode("img", {
            src: item.itemformdata[4][0].fileUrl,
            alt: ""
          }, null, 8, _hoisted_47)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_48, [_createElementVNode("h4", _hoisted_49, _toDisplayString(item.itemformdata.place_name), 1), item.itemformdata.map_type2 !== undefined ? (_openBlock(), _createElementBlock("p", _hoisted_50, _toDisplayString(item.itemformdata.map_type2), 1)) : _createCommentVNode("", true)]), _createElementVNode("i", {
            class: "icon icon-delete",
            onClick: _withModifiers($event => $options.pointhandle(3, item), ["stop"])
          }, null, 8, _hoisted_51)], 8, _hoisted_45);
        }), 128))]), _withDirectives(_createVNode(_component_el_empty, {
          "image-size": 80,
          description: "暂无数据"
        }, null, 512), [[_vShow, $props.pointlist.length === 0]])])]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onTabClick"])], 512), [[_vShow, $data.leftIndex === 3]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_collapse_item, {
      name: "16"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[128] || (_cache[128] = _createElementVNode("span", null, "选择样式", -1))]),
      default: _withCtx(() => [_createElementVNode("ul", _hoisted_52, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.popOptions, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass([{
            'active': $data.popStyleIndex === index
          }, {
            'none': $props.form.cTemplateScore !== item.score
          }]),
          key: index,
          onClick: $event => $options.popStyleChange(item, index)
        }, [_createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_cache[129] || (_cache[129] = _createElementVNode("i", {
          class: "icon-right"
        }, null, -1)), _createElementVNode("img", {
          src: item.url,
          alt: ""
        }, null, 8, _hoisted_56)]), _createElementVNode("h5", null, "样式" + _toDisplayString(index + 1), 1)])], 10, _hoisted_53);
      }), 128))])]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "17"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[130] || (_cache[130] = _createElementVNode("span", null, "外观", -1))]),
      default: _withCtx(() => [_createVNode(_component_gpickr, {
        title: "弹窗主题色",
        color: $props.style.popcolor,
        onColor: _cache[53] || (_cache[53] = $event => $options.popColorHandle($event, 'popcolor'))
      }, null, 8, ["color"])]),
      _: 1
    })], 512), [[_vShow, $data.leftIndex === 4]]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_57, [_createVNode(_component_el_radio_group, {
      modelValue: $props.form.showlistflag,
      "onUpdate:modelValue": _cache[54] || (_cache[54] = $event => $props.form.showlistflag = $event),
      onChange: _cache[55] || (_cache[55] = $event => $options.inputChange($event, 'showlistflag'))
    }, {
      default: _withCtx(() => [_createVNode(_component_el_radio, {
        value: 1
      }, {
        default: _withCtx(() => [...(_cache[131] || (_cache[131] = [_createTextVNode("显示列表", -1)]))]),
        _: 1
      }), _createVNode(_component_el_radio, {
        value: 2
      }, {
        default: _withCtx(() => [...(_cache[132] || (_cache[132] = [_createTextVNode("隐藏列表", -1)]))]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"])]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_collapse_item, {
      name: "24"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[133] || (_cache[133] = _createElementVNode("span", null, "选择样式", -1))]),
      default: _withCtx(() => [_createElementVNode("ul", _hoisted_58, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.listOptions, (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: _normalizeClass([{
            'active': $data.listStyleIndex === index
          }, {
            'none': $props.form.cTemplateScore !== item.score
          }]),
          key: index,
          onClick: $event => $options.listStyleChange(item, index)
        }, [_createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_cache[134] || (_cache[134] = _createElementVNode("i", {
          class: "icon-right"
        }, null, -1)), _createElementVNode("img", {
          src: item.url,
          alt: ""
        }, null, 8, _hoisted_62)]), _createElementVNode("h5", null, "样式" + _toDisplayString(index + 1), 1)])], 10, _hoisted_59);
      }), 128))])]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "25"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[135] || (_cache[135] = _createElementVNode("span", null, "定位", -1))]),
      default: _withCtx(() => [_createVNode(_component_map_position, {
        showWidth: false,
        name: "listpos",
        value: $props.style.listpos
      }, null, 8, ["value"])]),
      _: 1
    })], 512), [[_vShow, $props.form.showlistflag === 1]])], 512), [[_vShow, $data.leftIndex === 5]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_tabs, {
      modelValue: $data.switchtab3,
      "onUpdate:modelValue": _cache[69] || (_cache[69] = $event => $data.switchtab3 = $event),
      class: "switchTab1",
      onTabClick: $options.handleClick
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "样式",
        name: "first"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_63, [_createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [...(_cache[136] || (_cache[136] = [_createElementVNode("span", null, "路线按钮", -1)]))]),
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: $props.form.routebutton,
            "onUpdate:modelValue": _cache[56] || (_cache[56] = $event => $props.form.routebutton = $event),
            onChange: _cache[57] || (_cache[57] = $event => $options.inputChange($event, 'routebutton'))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              value: 1
            }, {
              default: _withCtx(() => [...(_cache[137] || (_cache[137] = [_createTextVNode("显示", -1)]))]),
              _: 1
            }), _createVNode(_component_el_radio, {
              value: 2
            }, {
              default: _withCtx(() => [...(_cache[138] || (_cache[138] = [_createTextVNode("隐藏", -1)]))]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _withDirectives(_createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [...(_cache[139] || (_cache[139] = [_createElementVNode("span", null, "自定义文字", -1)]))]),
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $props.form.routebuttontext,
            "onUpdate:modelValue": _cache[58] || (_cache[58] = $event => $props.form.routebuttontext = $event),
            onChange: _cache[59] || (_cache[59] = $event => $options.inputChange($event, 'routebuttontext'))
          }, null, 8, ["modelValue"])]),
          _: 1
        }, 512), [[_vShow, $props.form.routebutton === 1]]), _createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [...(_cache[140] || (_cache[140] = [_createElementVNode("span", null, "全部路线预览", -1)]))]),
          default: _withCtx(() => [_createVNode(_component_el_radio_group, {
            modelValue: $props.form.allroutepreview,
            "onUpdate:modelValue": _cache[60] || (_cache[60] = $event => $props.form.allroutepreview = $event),
            onChange: _cache[61] || (_cache[61] = $event => $options.inputChange($event, 'allroutepreview'))
          }, {
            default: _withCtx(() => [_createVNode(_component_el_radio, {
              value: 1
            }, {
              default: _withCtx(() => [...(_cache[141] || (_cache[141] = [_createTextVNode("显示", -1)]))]),
              _: 1
            }), _createVNode(_component_el_radio, {
              value: 2
            }, {
              default: _withCtx(() => [...(_cache[142] || (_cache[142] = [_createTextVNode("隐藏", -1)]))]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]), _createVNode(_component_el_collapse_item, {
          name: "27"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[143] || (_cache[143] = _createElementVNode("span", null, "按钮样式", -1))]),
          default: _withCtx(() => [_createVNode(_component_typebtn, {
            name: "routebtn",
            showTab: false,
            value: $props.style.routebtn
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_el_collapse_item, {
          name: "28"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[144] || (_cache[144] = _createElementVNode("span", null, "定位", -1))]),
          default: _withCtx(() => [_createVNode(_component_map_position, {
            showWidth: false,
            name: "routepos",
            value: $props.style.routepos
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_el_collapse_item, {
          name: "29"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[145] || (_cache[145] = _createElementVNode("span", null, "弹窗样式", -1))]),
          default: _withCtx(() => [_createVNode(_component_gpickr, {
            title: "主题色",
            color: $props.style.routepopcolor,
            onColor: _cache[62] || (_cache[62] = $event => $options.popColorHandle($event, 'routepopcolor'))
          }, null, 8, ["color"])]),
          _: 1
        }), _createVNode(_component_el_collapse_item, {
          name: "30"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[146] || (_cache[146] = _createElementVNode("span", null, "线条样式", -1))]),
          default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_radio_group, {
              class: "rowsWrap",
              modelValue: $props.form.routelinetype,
              "onUpdate:modelValue": _cache[63] || (_cache[63] = $event => $props.form.routelinetype = $event),
              onChange: _cache[64] || (_cache[64] = $event => $options.inputChange($event, 'routelinetype'))
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio, {
                value: 1
              }, {
                default: _withCtx(() => [...(_cache[147] || (_cache[147] = [_createTextVNode("真实路线 ", -1)]))]),
                _: 1
              }), _cache[150] || (_cache[150] = _createElementVNode("span", {
                class: "desc"
              }, [_createElementVNode("i", null, "*"), _createTextVNode("路线轨迹还原真实车行路线")], -1)), _createVNode(_component_el_radio, {
                value: 2
              }, {
                default: _withCtx(() => [...(_cache[148] || (_cache[148] = [_createTextVNode("直线", -1)]))]),
                _: 1
              }), _createVNode(_component_el_radio, {
                value: 3
              }, {
                default: _withCtx(() => [...(_cache[149] || (_cache[149] = [_createTextVNode("曲线", -1)]))]),
                _: 1
              }), _cache[151] || (_cache[151] = _createElementVNode("span", {
                class: "desc"
              }, [_createElementVNode("i", null, "*"), _createTextVNode("地图区域鼠标选中拖拽即可调整弯曲程度")], -1))]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_collapse_item, {
          name: "31"
        }, {
          title: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "icon"
          }, {
            default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
            _: 1
          }), _cache[152] || (_cache[152] = _createElementVNode("span", null, "轨迹动效图标", -1))]),
          default: _withCtx(() => [_createVNode(_component_uploadfile, {
            name: "routemoveicon",
            uploadList: $props.form.routemoveicon,
            onFileList: _cache[65] || (_cache[65] = $event => $options.fileListHandle($event, 'routemoveicon'))
          }, null, 8, ["uploadList"])]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "数据",
        name: "second"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_64, [_createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[66] || (_cache[66] = $event => $options.routehandle(0))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Plus)]),
            _: 1
          }), _cache[153] || (_cache[153] = _createTextVNode("新增路线", -1))]),
          _: 1
        }), _createVNode(_component_el_button, {
          plain: "",
          onClick: _cache[67] || (_cache[67] = $event => $options.routetypehandle(0))
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_component_Plus)]),
            _: 1
          }), _cache[154] || (_cache[154] = _createTextVNode("新增分类", -1))]),
          _: 1
        })]), _createVNode(_component_el_collapse, {
          class: "routecollapse",
          modelValue: $options.activeroute,
          "onUpdate:modelValue": _cache[68] || (_cache[68] = $event => $options.activeroute = $event)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.routetypelist, (item, index) => {
            return _openBlock(), _createBlock(_component_el_collapse_item, {
              name: index,
              key: index
            }, {
              title: _withCtx(() => [_createVNode(_component_el_icon, {
                class: "icon-bottom"
              }, {
                default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
                _: 1
              }), _createVNode(_component_el_icon, {
                class: "icon-right"
              }, {
                default: _withCtx(() => [_createVNode(_component_CaretRight)]),
                _: 1
              }), _createElementVNode("h4", null, _toDisplayString(item.itemformdata.title), 1), _createElementVNode("div", _hoisted_65, [_createVNode(_component_el_icon, {
                onClick: _withModifiers($event => $options.routehandle(0, item), ["stop"])
              }, {
                default: _withCtx(() => [_createVNode(_component_Plus)]),
                _: 1
              }, 8, ["onClick"]), _createElementVNode("i", {
                class: "icon icon-edit",
                onClick: _withModifiers($event => $options.routetypehandle(1, item), ["stop"])
              }, null, 8, _hoisted_66), index !== 0 ? (_openBlock(), _createElementBlock("i", {
                key: 0,
                class: "icon icon-delete",
                onClick: _withModifiers($event => $options.routetypehandle(3, item), ["stop"])
              }, null, 8, _hoisted_67)) : _createCommentVNode("", true)])]),
              default: _withCtx(() => [_createElementVNode("ul", _hoisted_68, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.getRouteItem($props.routelist, item.itemformdata.onlyid), (item, index) => {
                return _openBlock(), _createElementBlock("li", {
                  key: index
                }, [_createElementVNode("div", _hoisted_69, [_createElementVNode("h4", null, _toDisplayString(item.itemformdata.title), 1), _createElementVNode("div", _hoisted_70, [_createElementVNode("i", {
                  class: "icon icon-edit",
                  onClick: $event => $options.routehandle(1, item)
                }, null, 8, _hoisted_71), _createElementVNode("i", {
                  class: "icon icon-delete",
                  onClick: $event => $options.routehandle(3, item)
                }, null, 8, _hoisted_72)])])]);
              }), 128))])]),
              _: 2
            }, 1032, ["name"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue", "onTabClick"])], 512), [[_vShow, $data.leftIndex === 6]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_el_collapse_item, {
      name: "18"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[155] || (_cache[155] = _createElementVNode("span", null, "访问量", -1))]),
      default: _withCtx(() => [_createVNode(_component_el_checkbox, {
        class: "mb12",
        modelValue: $data.senior.visit,
        "onUpdate:modelValue": _cache[70] || (_cache[70] = $event => $data.senior.visit = $event),
        label: "开启访问量",
        onChange: _cache[71] || (_cache[71] = $event => $options.seniorChange($event, 'visit'))
      }, null, 8, ["modelValue"]), _withDirectives(_createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [...(_cache[156] || (_cache[156] = [_createElementVNode("span", null, "真实访问量", -1)]))]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          disabled: "",
          modelValue: $props.form.visits,
          "onUpdate:modelValue": _cache[72] || (_cache[72] = $event => $props.form.visits = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 512), [[_vShow, $data.senior.visit]]), _withDirectives(_createVNode(_component_el_form_item, null, {
        label: _withCtx(() => [...(_cache[157] || (_cache[157] = [_createElementVNode("span", null, "自定义访问增量", -1)]))]),
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $props.form.customvisits,
          "onUpdate:modelValue": _cache[73] || (_cache[73] = $event => $props.form.customvisits = $event)
        }, null, 8, ["modelValue"])]),
        _: 1
      }, 512), [[_vShow, $data.senior.visit]]), _withDirectives(_createVNode(_component_el_collapse_item, {
        class: "hastopPadding",
        name: "32"
      }, {
        title: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
          _: 1
        }), _cache[158] || (_cache[158] = _createElementVNode("span", null, "样式", -1))]),
        default: _withCtx(() => [_createVNode(_component_el_form_item, null, {
          label: _withCtx(() => [...(_cache[159] || (_cache[159] = [_createElementVNode("span", null, "自定义文字", -1)]))]),
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: $data.senior.visitname,
            "onUpdate:modelValue": _cache[74] || (_cache[74] = $event => $data.senior.visitname = $event),
            onChange: _cache[75] || (_cache[75] = $event => $options.seniorChange($event, 'visitname'))
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_typebtn, {
          name: "visitdom",
          title: "",
          showTab: false,
          value: $props.style.visitdom
        }, null, 8, ["value"])]),
        _: 1
      }, 512), [[_vShow, $data.senior.visit]]), _withDirectives(_createVNode(_component_el_collapse_item, {
        class: "hastopPadding",
        name: "33"
      }, {
        title: _withCtx(() => [_createVNode(_component_el_icon, null, {
          default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
          _: 1
        }), _cache[160] || (_cache[160] = _createElementVNode("span", null, "定位", -1))]),
        default: _withCtx(() => [_createVNode(_component_map_position, {
          showWidth: false,
          name: "visitpos",
          value: $props.style.visitpos
        }, null, 8, ["value"])]),
        _: 1
      }, 512), [[_vShow, $data.senior.visit]])]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "21"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[161] || (_cache[161] = _createElementVNode("span", null, "进入特效", -1))]),
      default: _withCtx(() => [_createVNode(_component_el_checkbox, {
        modelValue: $data.senior.effect,
        "onUpdate:modelValue": _cache[76] || (_cache[76] = $event => $data.senior.effect = $event),
        label: "开启特效",
        onChange: _cache[77] || (_cache[77] = $event => $options.seniorChange($event, 'effect'))
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "35"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[162] || (_cache[162] = _createElementVNode("span", null, "背景音乐", -1))]),
      default: _withCtx(() => [_createVNode(_component_el_checkbox, {
        class: "mb12",
        modelValue: $data.senior.bgaudio,
        "onUpdate:modelValue": _cache[78] || (_cache[78] = $event => $data.senior.bgaudio = $event),
        label: "开启背景音乐",
        onChange: _cache[79] || (_cache[79] = $event => $options.seniorChange($event, 'bgaudio'))
      }, null, 8, ["modelValue"]), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_73, [_cache[163] || (_cache[163] = _createElementVNode("div", {
        class: "title-label mb5"
      }, "播放图标", -1)), _createVNode(_component_uploadfile, {
        name: "bgaudiostarticon",
        uploadList: $props.form.bgaudiostarticon,
        width: 70,
        height: 70,
        onFileList: _cache[80] || (_cache[80] = $event => $options.fileListHandle($event, 'bgaudiostarticon'))
      }, null, 8, ["uploadList"]), _cache[164] || (_cache[164] = _createElementVNode("div", {
        class: "title-label mt15 mb5"
      }, "暂停图标", -1)), _createVNode(_component_uploadfile, {
        name: "bgaudioendicon",
        uploadList: $props.form.bgaudioendicon,
        width: 70,
        height: 70,
        onFileList: _cache[81] || (_cache[81] = $event => $options.fileListHandle($event, 'bgaudioendicon'))
      }, null, 8, ["uploadList"])]), _createVNode(_component_map_position, {
        name: "bgaudiopos",
        value: $props.style.bgaudiopos
      }, null, 8, ["value"]), _cache[165] || (_cache[165] = _createElementVNode("div", {
        class: "title-label mt15 mb5"
      }, "音频文件", -1)), _createVNode(_component_el_form_item, null, {
        default: _withCtx(() => [_createVNode(_component_uploadfile, {
          styletype: 3,
          uploadList: $props.form.bgaudiofile,
          name: $props.formlabel.bgaudiofile,
          field: $props.formfield.bgaudiofile,
          onFileList: _cache[82] || (_cache[82] = $event => $options.fileListHandle($event, 'bgaudiofile'))
        }, null, 8, ["uploadList", "name", "field"])]),
        _: 1
      })], 512), [[_vShow, $data.senior.bgaudio]])]),
      _: 1
    }), _createVNode(_component_el_collapse_item, {
      name: "36"
    }, {
      title: _withCtx(() => [_createVNode(_component_el_icon, null, {
        default: _withCtx(() => [_createVNode(_component_CaretBottom)]),
        _: 1
      }), _cache[166] || (_cache[166] = _createElementVNode("span", null, "图片组件", -1))]),
      default: _withCtx(() => [_createElementVNode("div", {
        class: "defaultPic",
        draggable: "true",
        onDragstart: _cache[83] || (_cache[83] = (...args) => $options.pichandleDragStart && $options.pichandleDragStart(...args))
      }, [_createElementVNode("img", {
        src: $data.defaultupImg,
        alt: ""
      }, null, 8, _hoisted_74)], 32)]),
      _: 1
    })], 512), [[_vShow, $data.leftIndex === 7]])]),
    _: 1
  }, 8, ["modelValue", "onChange"])])], 2)], 64);
}